import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  BulkUpdateUserAttributes,
  Submission,
} from 'src/app/core/models/submission.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SubmissionService {
  constructor(private http: HttpClient) { }
  
  // status, startDate, endDate
  getSubmissions(status: any = 0, startDate: any, endDate: any, formId: any = null) {
    const id = formId !== null ? `&formId=${formId}` : '';
    return this.http.get<Submission[]>(`/api/submission?status=${status}&startDate=${startDate}&endDate=${endDate}${id}`);
  }

  getSubmission(id: string) {
    return this.http.get<Submission>(`/api/submission/${id}`);
  }

  create(submission: Submission): Observable<any> {
    return this.http.post(`/api/submission`, submission);
  }

  update(submission: Submission) {
    return this.http.put(`/api/submission`, submission);
  }

  validateCaptcha(token: string) {
    return this.http.get(`/api/submission/validatetoken/${token}`);
  }

  sendActivationMail(id: string) {
    return this.http.post(`/api/activation/${id}/mail`, null);
  }

  activate(id: string, password: string): Observable<any> {
    return this.http.put(`/api/activation/${id}?password=${password}`, null);
  }

  updateStatus(id: string, status: number) {
    return this.http.put(`/api/submission/${id}/status/${status}`, null);
  }

  bulkUpdateSubmissions(bulkUpdateSubmissions: BulkUpdateUserAttributes) {
    return this.http.put(`/api/submission/api/submission/bulkupdate`, bulkUpdateSubmissions);
  }
}
